<crm-form-loading-indicator [loadingStatus]="loadingStatus">
  <form class="crm-model-driven-form" form-content [formGroup]="formGroup">
    <crm-vertical-nav-tab>
      <ng-container *ngFor="let fieldGroup of renderableFieldGroups">
        <crm-vertical-nav-card
          *ngIf="fieldGroup.editableFieldCount > 0"
          [label]="
            fieldGroup.description
              ? (fieldGroup.description | translate)
              : ('STANDARD_FIELD_GROUPS.CUSTOM_FIELDS' | translate)
          "
        >
          <mat-card appearance="outlined">
            <mat-card-content class="crm-model-card-content">
              <ng-container *ngFor="let renderableField of fieldGroup.fields">
                <crm-renderer-selector [handler]="renderableField"></crm-renderer-selector>
              </ng-container>
            </mat-card-content>
          </mat-card>
        </crm-vertical-nav-card>
      </ng-container>
    </crm-vertical-nav-tab>
    <glxy-sticky-footer *ngIf="!readOnly">
      <ng-template [ngTemplateOutlet]="formButtons"></ng-template>
    </glxy-sticky-footer>
  </form>
</crm-form-loading-indicator>
<ng-template #formButtons>
  <crm-form-button-group
    [submitButtonText]="submitButtonText | translate"
    [cancelButtonText]="cancelButtonText | translate"
    [savingStatus]="savingStatus"
    (clickedOnSubmit)="onSubmit()"
    (clickedOnCancel)="onCancel()"
  ></crm-form-button-group>
</ng-template>
